
import React from "react";
import { motion } from "framer-motion";
import { cn } from "@/lib/utils";
import { Link } from "react-router-dom";

interface HeroBadgeProps {
  href?: string;
  text: string;
  icon?: React.ReactNode;
  endIcon?: React.ReactNode;
  variant?: "default" | "outline" | "ghost";
  size?: "sm" | "md" | "lg";
  className?: string;
  onClick?: () => void; // Add onClick prop
}

const HeroBadge = ({
  href,
  text,
  icon,
  endIcon,
  variant = "default",
  size = "md",
  className,
  onClick, // Add onClick to the component props
}: HeroBadgeProps) => {
  const variants = {
    default: "bg-primary/10 text-primary",
    outline: "border border-border bg-background/50",
    ghost: "bg-muted/50",
  };

  const sizes = {
    sm: "text-xs px-2 py-0.5",
    md: "text-sm px-3 py-1",
    lg: "px-4 py-1.5",
  };

  const pillContent = (
    <div
      className={cn(
        "inline-flex items-center gap-1.5 rounded-full font-medium",
        variants[variant],
        sizes[size],
        onClick ? "cursor-pointer" : "", // Add cursor pointer if onClick is provided
        className
      )}
      onClick={onClick} // Add onClick handler
    >
      {icon}
      <span>{text}</span>
      {endIcon}
    </div>
  );

  return (
    <motion.div
      initial={{ opacity: 0, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5 }}
    >
      {href ? <Link to={href}>{pillContent}</Link> : pillContent}
    </motion.div>
  );
};

export default HeroBadge;
